import styled from 'styled-components';
import { Card } from 'antd';

export const DashboardContainer = styled.div`
  padding: 24px;
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
`;

export const PageHeader = styled.div`
  margin-bottom: 24px;

  h1 {
    font-size: 32px;
    font-weight: 600;
    color: #262626;
    margin: 0;
  }

  p {
    color: #8c8c8c;
    margin: 4px 0 0 0;
    font-size: 16px;
  }
`;

export const QuickActions = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const StatsCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }

  .ant-statistic-title {
    color: #8c8c8c;
    font-weight: 500;
    font-size: 14px;
  }

  .ant-statistic-content {
    color: #262626;
  }

  .ant-statistic-content-value {
    font-weight: 600;
  }
`;

export const RecentDossiersCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;

  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-card-head-title {
    font-weight: 600;
    color: #262626;
  }
`;

export const ChartCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;
  height: 320px;

  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-card-head-title {
    font-weight: 600;
    color: #262626;
  }

  .ant-card-body {
    padding: 16px;
  }
`;

export const UserStatsCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;

  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-card-head-title {
    font-weight: 600;
    color: #262626;
  }
`;

export const ProgressCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;
  height: 320px;

  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-card-head-title {
    font-weight: 600;
    color: #262626;
  }

  .ant-card-body {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 60px);
  }
`;